if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			if ( ! this.hasAttribute('data-empty-product' ) ) {

				this.productGallery = this.querySelector('.product-gallery');
				this.productSlider = this.querySelector('css-slider');
                if (this.dataset.bstoreOccasion === 'true' || this.classList.contains('bstore-gallery-preview')) {
                    this.productGallery.addEventListener('click', event => {
                        const item = event.target.closest('.product-gallery-item');
                        if (!item || !this.productGallery.contains(item)) return;
                        const color = this.photoInfo(item.querySelector('img')).color;
                        if (!color) return;
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        this.showColorPreview(item, color);
                    }, true);
                }
                if (this.classList.contains('bstore-gallery-preview')) {
                    this.productGallery.querySelectorAll('.product-gallery-item').forEach(item => {
                        const view = this.photoInfo(item.querySelector('img')).view;
                        item.classList.toggle('bstore-back-view', /^back(?: view)?$/i.test(view || '') && this.dataset.bstoreSingleColor !== 'true');
                    });
                }

                const colorVariants = this.querySelector('product-variants');
                const syncColorSwatches = () => {
                    this.querySelectorAll('.product-variant__item--color .product-variant__label').forEach(label => {
                        const dot = label.querySelector('span');
                        const input = this.querySelector('#' + CSS.escape(label.htmlFor));
                        if (!dot || !input || dot.querySelector('svg')) return;
                        if (getComputedStyle(dot).backgroundImage !== 'none' || getComputedStyle(dot).backgroundColor !== 'rgba(0, 0, 0, 0)') return;
                        const image = Array.from(this.productGallery.querySelectorAll('.product-gallery-item img')).find(img => {
                            const info = this.photoInfo(img);
                            return info.color.toLowerCase() === input.value.trim().toLowerCase() && info.view === 'front';
                        });
                        if (!image) return;
                        dot.style.backgroundImage = 'url("' + (image.currentSrc || image.src) + '")';
                        dot.style.backgroundSize = 'cover';
                        dot.style.backgroundPosition = 'center';
                        dot.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,.2)';
                    });
                };
                syncColorSwatches();
                if (colorVariants) {
                    new MutationObserver(syncColorSwatches).observe(colorVariants, {childList:true,subtree:true});
                    colorVariants.addEventListener('click', event => {
                        const label = event.target.closest('.product-variant__item--color .product-variant__label');
                        if (!label) return;
                        const input = this.querySelector('#' + CSS.escape(label.htmlFor));
                        if (!input?.checked) return;
                        const item = Array.from(this.productGallery.querySelectorAll('.product-gallery-item')).find(item => {
                            const info = this.photoInfo(item.querySelector('img'));
                            return info.color.toLowerCase() === input.value.trim().toLowerCase() && info.view === 'front';
                        });
                        if (item) this.showColorPreview(item, input.value.trim());
                    });
                }

				// Gallery thumbnails

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )
							elm.classList.add('active');
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-faux-index="${e.currentTarget.hasAttribute('data-faux-index') ? e.currentTarget.dataset.fauxIndex : e.currentTarget.dataset.index }"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.fauxIndex);
							}
							this._pauseAllMedia();
							//playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
						});
					})

					if ( this.productSlider ) {
						this.productSlider.addEventListener('change', e=>{
							this.thumbnailNavigationHelper(e.target.index);
						});
					}

				}

				if ( this.productSlider ) {
					this.productSlider.addEventListener('change', e=>{
						if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' && this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						this._pauseAllMedia();
						this.thumbnailNavigationHelper(e.target.index);
					});
				}

				// Product variant event listener for theme specific logic

				const productVariants = this.querySelector('product-variants');
				if ( productVariants ) {
					productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
					this.onVariantChangeHandler({target:productVariants});
				}

				// show cart drawer when element is added to cart

				if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {

					let addToCartEnter = false;
					if ( this.querySelector('.product--add-to-cart-button') ) {
						this.querySelector('.product--add-to-cart-button').addEventListener('keyup', e=>{
							if ( e.keyCode == window.KEYCODES.RETURN ) {
								addToCartEnter = true;
							}
						})
					}

					if ( this.querySelector('.product--add-to-cart-form') ) {
						this.querySelector('.product--add-to-cart-form').addEventListener('add-to-cart', ()=>{
							document.getElementById('site-cart').show();
							if ( document.getElementById('cart-recommendations') ) {
								document.getElementById('cart-recommendations').generateRecommendations();
							}
							if ( addToCartEnter ) {
								setTimeout(()=>{
									document.querySelector('#site-cart .site-close-handle').focus();
								}, 200);
							}
						});
					}

				}

				// Scroll navigation helper 

				if ( this.productGallery.dataset.style == "scroll" ) {

					this.productGalleryNavigation = this.querySelector('.product-gallery__thumbnails');
					this.productGalleryNavigationItem = this.querySelectorAll('.product-gallery__thumbnails .thumbnail');

					const productGallerySlides = this.productGallery.querySelectorAll('.product-gallery-item');
					const reversedGallerySlides = [...productGallerySlides].reverse();

					const checkIfProductIsFirst = this.parentNode == document.querySelector('#main .mount-product-page:first-child') ? document.querySelector('#main .mount-product-page:first-child .product-gallery__thumbnails') : false;

					this.GALLERY_NAVIGATION_SCROLL = () => { 
						if ( ! this.productGallery.querySelector('css-slider').sliderEnabled && window.innerWidth > 768 ) {

							for ( const slide of reversedGallerySlides ) {
								const slideTop = slide.getBoundingClientRect().top;
								if ( slideTop < window.innerHeight / 2 && slideTop > -window.innerHeight / 2  ) {
									this.productGalleryNavigationItem.forEach(elm=>elm.classList.remove('active'));
									this.productGalleryNavigationItem[slide.dataset.fauxIndex].classList.add('active');
									break;
								} 
							}

							const productGalleryTop = this.productGallery.getBoundingClientRect().top;
							if ( (productGalleryTop - window.innerHeight) * -1 > this.productGallery.offsetHeight ) {
								this.productGalleryNavigation.classList.add('scroll');
								this.productGalleryNavigation.classList.remove('scroll-up');
							} else if ( productGalleryTop > 0 ) {
								this.productGalleryNavigation.classList.add('scroll-up');
								this.productGalleryNavigation.classList.add('scroll');
								if ( checkIfProductIsFirst ) {
									checkIfProductIsFirst.style.height = `calc( var(--window-height) + ${window.scrollY}px )`;
								}
							} else if ( (productGalleryTop - window.innerHeight) * -1 < this.productGallery.offsetHeight ) {
								this.productGalleryNavigation.classList.remove('scroll');
								this.productGalleryNavigation.classList.remove('scroll-up');
							}

						}

					}

					window.addEventListener('scroll', this.GALLERY_NAVIGATION_SCROLL, {passive:true});
					this.GALLERY_NAVIGATION_SCROLL();

				}

				// Check for models

				const models = this.querySelectorAll('product-model');
				if ( models.length > 0 ) {
					window.ProductModel.loadShopifyXR();
					this.xrButton = this.querySelector('.product__view-in-space');
				}

				// Change sticky position for text content

				const productContentBox = this.querySelector('.box__product-content');
				const productGalleryBox = this.querySelector('.box__product-gallery');

				this.CONTENT_STICKY_RESIZE = () => {
					productContentBox.style.top = `calc(100vh - ${productContentBox.offsetHeight+1}px)`;
					productGalleryBox.style.top = `calc(100vh - ${productGalleryBox.offsetHeight+1}px)`;
				}
				window.addEventListener('resize', this.CONTENT_STICKY_RESIZE, {passive:true});
				this.CONTENT_STICKY_RESIZE();

				const contentObserver = new MutationObserver(mutations=>{
					for ( const mutation of mutations ) {
						this.CONTENT_STICKY_RESIZE();
					}
				});
				contentObserver.observe(productContentBox,{ attributes: true, childList: true, subtree: true });

				// Assist for video popups
				
				if ( this.productGallery.querySelector('video-popup') ) {
					
					const productVideoObserver = new MutationObserver(mutations=>{
						for ( const mutation of mutations ) {
							if ( mutation.target.classList.contains('video-opened') ) {
								this.productGallery.classList.add('remove-navigation');
							} else {
								this.productGallery.classList.remove('remove-navigation');
							}
						}
					});
					this.productGallery.querySelectorAll('video-popup').forEach(elm=>{
						productVideoObserver.observe(elm,{ attributes: true, childList: false, subtree: false });
					})

				}

			}

		}

		thumbnailNavigationHelper(index=0){
			if ( this.querySelector('.product-gallery__thumbnails') ) {
				this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
					if ( !elm.hidden && Number(elm.dataset.index) === Number(index) )
						elm.classList.add('active');
					else 
						elm.classList.remove('active');
				});
				setTimeout(()=>{
					const active = this.querySelector('.product-gallery__thumbnails .thumbnail.active');
                    if (active) this.querySelector('.thumbnails-holder').scrollLeft = active.offsetLeft - active.offsetWidth;
				}, 50);
			}
		}

		onVariantChangeHandler(e){
			const variant = e.target.currentVariant;
			if ( variant && variant.featured_media != null ) {
				const variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
				if ( variantImg ) {
                    if (this.classList.contains('bstore-gallery-preview') && (window.matchMedia('(min-width:768px)').matches || this.dataset.bstoreOccasion === 'true')) {
                        const color = this.photoInfo(variantImg.querySelector('img')).color || String(variant.featured_media.id);
                        const previousColor = this._bstoreDesktopColor;
                        this._bstoreDesktopColor = color;
                        if (e.type && previousColor !== color) this.showColorPreview(variantImg, color);
                        return;
                    }
					const mediaId = String(variant.featured_media.id);
					if ( this._bstoreVariantMediaId === mediaId ) return;
					this._bstoreVariantMediaId = mediaId;
					if ( this.productGallery.dataset.style == "slider" || ( this.productGallery.dataset.style == "scroll" && this.productGallery.querySelector('css-slider').sliderEnabled ) ) {
						this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
					} else {
						const originalOrder = [...this.productGallery.querySelectorAll('.product-gallery-item')].sort((a,b)=>{
							return a.dataset.index - b.dataset.index;
						});

						originalOrder.forEach(elm=>{
							this.productGallery.querySelector('css-slider').append(elm)
						})
						const mediaColor = this.photoInfo(variantImg.querySelector('img')).color.toLowerCase();
						const relatedImages = mediaColor ? originalOrder.filter(item => item !== variantImg && this.photoInfo(item.querySelector('img')).color.toLowerCase() === mediaColor) : [];
						this.productGallery.querySelector('css-slider').prepend(variantImg, ...relatedImages);
						this.reorderThumbnailNavigation();
					}
				}
			}
		}

        photoInfo(image) {
            const parts = (image?.alt || '').split(/\||\s+[—–]\s+/).map(part => part.trim());
            const normalize = value => value.replace(/_/g, ' ').replace(/^\d+[\s-]+/, '').replace(/\s+/g, ' ').trim();
            const standalone = parts.slice(1).find(part => /^(front|back)(?: view)?$/i.test(part));
            if (standalone) return {color: normalize(parts[1] || ''), view: standalone.toLowerCase().replace(/ view$/, '')};
            for (const part of parts.slice(1).reverse()) {
                const match = normalize(part).match(/^(.+?)\s+(front|back)(?: view)?$/i);
                if (match) return {color: match[1].trim(), view: match[2].toLowerCase()};
            }
            return {color: normalize(parts[1] || ''), view: ''};
        }

        showColorPreview(variantImg, color) {
            const panel = this.querySelector('.bstore-color-preview');
            if (!panel) return;
            let all = Array.from(this.productGallery.querySelectorAll('.product-gallery-item img'));
            if (this.classList.contains('bstore-gallery-preview') && this.productSlider.originalHTML) {
                const template = document.createElement('template');
                template.innerHTML = this.productSlider.originalHTML;
                all = Array.from(template.content.querySelectorAll('.product-gallery-item img'));
            }
            const selected = variantImg.querySelector('img');
            const matches = all.filter(img => this.photoInfo(img).color.toLowerCase() === color.toLowerCase() && (img.alt || '').split('|')[0].trim() === (selected.alt || '').split('|')[0].trim());
            this._colorPhotos = matches.length ? matches : [selected];
            this._colorIndex = Math.max(0, this._colorPhotos.findIndex(img => img === selected || this.photoInfo(img).view === 'front'));
            if (!this._colorPreviewBound) {
                this._colorPreviewBound = true;
                panel.querySelectorAll('[data-color-view]').forEach(button => button.addEventListener('click', () => {
                    const index = this._colorPhotos.findIndex(img => new RegExp(`^${button.dataset.colorView}(?: view)?$`, 'i').test(this.photoInfo(img).view));
                    if (index >= 0) { this._colorIndex = index; this.renderColorPreview(); }
                }));
                panel.querySelector('[data-color-close]').addEventListener('click', () => { panel.hidden = true; });
                panel.querySelector('[data-color-prev]').addEventListener('click', () => { this._colorIndex = (this._colorIndex + this._colorPhotos.length - 1) % this._colorPhotos.length; this.renderColorPreview(); });
                panel.querySelector('[data-color-next]').addEventListener('click', () => { this._colorIndex = (this._colorIndex + 1) % this._colorPhotos.length; this.renderColorPreview(); });
                this.addEventListener('keydown', event => { if (event.key === 'Escape' && !panel.hidden) panel.hidden = true; });
                window.addEventListener('resize', () => this.positionColorPreview());
                window.addEventListener('scroll', () => this.positionColorPreview(), {passive:true});
            }
            panel.hidden = false;
            this.renderColorPreview();
            this.positionColorPreview();
        }

        renderColorPreview() {
            const panel = this.querySelector('.bstore-color-preview');
            const source = this._colorPhotos[this._colorIndex];
            const target = panel.querySelector('[data-color-image]');
            target.src = source.currentSrc || source.src;
            target.alt = source.alt;
            panel.querySelector('[data-color-caption]').textContent = [this.photoInfo(source).color, this.photoInfo(source).view].filter(Boolean).join(' · ') || source.alt;
            const currentView = this.photoInfo(source).view;
            panel.querySelectorAll('[data-color-view]').forEach(button => {
                const pattern = new RegExp(`^${button.dataset.colorView}(?: view)?$`, 'i');
                button.hidden = !this._colorPhotos.some(img => pattern.test(this.photoInfo(img).view));
                button.setAttribute('aria-pressed', String(pattern.test(currentView)));
            });
            panel.querySelector('[data-color-count]').textContent = /^(front|back)(?: view)?$/i.test(currentView) ? '' : currentView;
            panel.querySelectorAll('[data-color-prev],[data-color-next]').forEach(button => { button.disabled = this._colorPhotos.length < 2; });
        }

        positionColorPreview() {
            const panel = this.querySelector('.bstore-color-preview');
            if (!panel || panel.hidden) return;
            if (!window.matchMedia('(min-width:768px)').matches) {
                if (this.dataset.bstoreOccasion !== 'true') { panel.hidden = true; return; }
                panel.style.height = `${Math.min(780, window.innerHeight - 32)}px`;
                panel.style.width = `${Math.min(480, window.innerWidth - 32)}px`;
                panel.style.left = '50%';
                panel.style.top = '16px';
                return;
            }
            const box = this.productGallery.getBoundingClientRect();
            if (box.bottom < 120 || box.top > window.innerHeight - 120) { panel.hidden = true; return; }
            const top = Math.max(16, box.top);
            const available = Math.min(window.innerHeight - 86, box.bottom) - top;
            panel.style.height = `${Math.max(180, Math.min(780, available))}px`;
            panel.style.width = `${Math.min(box.width - 32, Math.max(180, available - 96) * 0.667 + 24)}px`;
            panel.style.left = `${box.left + box.width / 2}px`;
            panel.style.top = `${top + Math.max(0, (available - Math.min(780, available)) / 2)}px`;
        }

		reorderThumbnailNavigation(index){
			const reversedGallerySlidesForThumbnails = [...this.productGallery.querySelectorAll('.product-gallery-item')].reverse();
			const galleryThumbnailsHolder = this.querySelector('.product-gallery__thumbnails .thumbnails-holder .thumbnails');
			reversedGallerySlidesForThumbnails.forEach(slide=>{
				galleryThumbnailsHolder.prepend(this.querySelector(`.product-gallery__thumbnails .thumbnail[data-faux-index="${slide.dataset.index}"]`));
			})
			this.querySelectorAll('.product-gallery__thumbnails .thumbnails-holder .thumbnail').forEach((elm, i) => {
				elm.setAttribute('data-index', i);
			})
			this.thumbnailNavigationHelper(0);
			setTimeout(()=>{
				this.thumbnailNavigationHelper(0);
			}, 10);
		}

		_pauseAllMedia(){
			document.querySelectorAll('.product .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product video').forEach(video => video.pause());
			document.querySelectorAll('.product product-model').forEach(model => {
				if ( model.modelViewerUI ) 
					model.modelViewerUI.pause()
			});
		}

		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					media.querySelector('video').play();
					break;
				case 'external_video-youtube':
					media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					break;
				case 'external_video-vimeo':
					media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					break;
			}
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}

